import {
	ChangeDetectionStrategy,
	Component,
	HostBinding,
	Inject,
	Optional,
	ViewChild,
	ViewEncapsulation,
} from "@angular/core";
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from "@angular/material/legacy-dialog";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";

import { DialogLayoutComponent } from "../dialog-layout.component";

@Component({
	selector: "obg-m-iframe-dialog-layout",
	templateUrl: "./iframe-dialog-layout.component.html",
	styleUrls: ["./iframe-dialog-layout.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class IframeDialogLayoutComponent {
	@HostBinding("class.obg-m-iframe-dialog-layout") hostClass = true;

	titleText: string | undefined;
	src: SafeResourceUrl | undefined;

	@ViewChild("dialog", { static: true }) dialogLayout!: DialogLayoutComponent;

	constructor(
		private sanitizer: DomSanitizer,
		@Optional() @Inject(MAT_DIALOG_DATA) public data: { titleText: string; src: string } | undefined
	) {
		this.titleText = this.data?.titleText;
		this.src = this.sanitizer.bypassSecurityTrustResourceUrl(this.data?.src || "");
	}
}
